import { render, staticRenderFns } from "./like.vue?vue&type=template&id=c8c2189c&scoped=true"
import script from "./like.vue?vue&type=script&lang=js"
export * from "./like.vue?vue&type=script&lang=js"
import style0 from "./like.vue?vue&type=style&index=0&id=c8c2189c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c2189c",
  null
  
)

export default component.exports